/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TechStackTemplateDto } from '../models/tech-stack-template-dto';
import { TechStackTemplateRefDto } from '../models/tech-stack-template-ref-dto';

@Injectable({
  providedIn: 'root',
})
export class TechStackTemplateService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTechStackTemplates
   */
  static readonly GetTechStackTemplatesPath = '/techstack-templates';

  /**
   * Get Tech Stack Templates available for the user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechStackTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStackTemplates$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TechStackTemplateRefDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackTemplateService.GetTechStackTemplatesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TechStackTemplateRefDto>>;
      })
    );
  }

  /**
   * Get Tech Stack Templates available for the user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTechStackTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStackTemplates(params?: {
  }): Observable<Array<TechStackTemplateRefDto>> {

    return this.getTechStackTemplates$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TechStackTemplateRefDto>>) => r.body as Array<TechStackTemplateRefDto>)
    );
  }

  /**
   * Path part for operation getTechStackTemplateById
   */
  static readonly GetTechStackTemplateByIdPath = '/techstack-templates/{id}';

  /**
   * Get Tech Stack Template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechStackTemplateById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStackTemplateById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<TechStackTemplateDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackTemplateService.GetTechStackTemplateByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackTemplateDto>;
      })
    );
  }

  /**
   * Get Tech Stack Template.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTechStackTemplateById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStackTemplateById(params: {
    id: string;
  }): Observable<TechStackTemplateDto> {

    return this.getTechStackTemplateById$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackTemplateDto>) => r.body as TechStackTemplateDto)
    );
  }

}
